import { defineComponent } from 'vue'
import { type IRadioGroupProps } from './types'
import RadioInput from '../radio-input'
import { computed } from 'vue'
import { ref } from 'vue'
import type { IRadioInputProps } from '../radio-input/types'
import { toString } from '@/utils/formatting'

const RadioGroup = defineComponent<IRadioGroupProps>({
  name: 'RadioGroup',
  setup(props) {
    const { onIndexChange } = props

    const items = computed(() => {
      if (props.options && props.options.items && props.options.items.length > 0) {
        return props.options.items.map((it) =>
          props.options
            ? ({
                asButton: it.asButton,
                buttonProps: it.buttonProps,
                name: it.label || it.name || toString(it.value),
                identifier: it.name || it.label || undefined,
                selectedStyle: props.options?.selectedStyle || it.selectedStyle,
                selectedClass: props.options?.selectedClass || it.selectedClass,
                notSelectedClass: props.options?.notSelectedClass || it.notSelectedClass,
                notSelectedStyle: props.options?.notSelectedStyle || it.notSelectedStyle,
                css: props.options.css,
                value: it.value
              } as IRadioInputProps)
            : {}
        )
      }

      return props.items
    })

    const initialSelectedIndex = computed<number>(() => {
      const item = items.value.find((it) => !!it.value)
      if (!item) return 0
      return items.value.indexOf(item)
    })

    const selectedIndex = ref<number>(initialSelectedIndex.value)

    const handleClick = (item: IRadioInputProps, i: number) => {
      selectedIndex.value = i

      if (onIndexChange) {
        onIndexChange(i, item)
      }

      if (props.fieldRef) {
        // @ts-ignore
        props.fieldRef.value.value = item.value
      }

      if (props.reportChange && props.fieldRef) {
        props.reportChange(props.fieldRef)
      }
    }

    return () => {
      return (
        <div class="w-full h-full">
          {items.value.map((item, i) => {
            return (
              <RadioInput
                {...item}
                key={`${item.name || ''}-${i === selectedIndex.value}`}
                selected={i === selectedIndex.value}
                onClick={() => handleClick(item, i)}
                style={item.css}
              />
            )
          })}
        </div>
      )
    }
  }
})

RadioGroup.props = ['items', 'onIndexChange', 'options', 'fieldRef', 'reportChange', 'type']

export default RadioGroup
